export function getChipLabel({ label, showLabel, valueLabel }) {
    if (!valueLabel) {
        return;
    }
    if (showLabel && label) {
        return `${label}: ${valueLabel}`;
    }
    return `${valueLabel}`;
}
